import { ContractAnonymousViewModel, ServiceKind } from '@ail/contracts-api'

interface VehicleService {
  kind: ServiceKind
  icon: string
  label: string
}

const displayedServices: VehicleService[] = [
  {
    kind: ServiceKind.Rmt,
    icon: 'icon-rmt',
    label: 'Service & Maintenance',
  },
  {
    kind: ServiceKind.Vignette,
    icon: 'icon-vignette',
    label: 'Vignette',
  },
  {
    kind: ServiceKind.Tires,
    icon: 'icon-tire-storage',
    label: 'Tires Service & Storage',
  },
  {
    kind: ServiceKind.ReliefVehicle,
    icon: 'icon-reliefVehicle',
    label: 'Relief Vehicle',
  },
  {
    kind: ServiceKind.Fuel,
    icon: 'icon-fuel',
    label: 'Fuel',
  },
  {
    kind: ServiceKind.CarWash,
    icon: 'icon-car-wash',
    label: 'Carwash',
  },
]

export function VehicleServicesComponent(props: { contract?: ContractAnonymousViewModel }) {
  const { contract } = props

  const activeServices =
    contract?.services?.reduce(
      (result, service) => {
        if (service.kind) {
          result[service.kind] = true
        }
        return result
      },
      {} as Record<string, boolean>
    ) ?? {}

  return (
    <div className="col-23 col-md-6 vehicleServicesComponent">
      <div className="box-title">
        <span>
          <i className="icon-actions"></i> Services
        </span>
      </div>
      <div className="box2">
        <div className="actionInfo">
          <i className="icon-close"></i>
          <div className="infoTitle">
            <i className="icon-tires"></i>
            Tires
          </div>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
            industry&apos;s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and
            scrambled it to make a type specimen book.
          </p>
        </div>
        <ul className="actionsList">
          {displayedServices.map((s, i) => (
            <li key={i}>
              <div className={`actionBox ${activeServices[s.kind] ? 'active' : 'none'}`}>
                <div className="action">
                  <i className={s.icon}></i>
                  {s.label}

                  {activeServices[s.kind] ? <i className="icon-info"></i> : null}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}